(() => {
  if (window.nhNewsletterDialog) return;
  window.nhNewsletterDialog = true;
  let cleanup;

  function mount() {
    if (cleanup) cleanup();
    const section = document.querySelector('[data-nh-newsletter]');
    if (!section) return;
    const dialog = section.querySelector('dialog');
    const source = section.querySelector('[data-nh-newsletter-source]');
    const formHost = section.querySelector('[data-nh-newsletter-form]');
    const slot = section.querySelector('[data-nh-newsletter-slot]');
    const loading = section.querySelector('[data-nh-newsletter-loading]');
    const unavailable = section.querySelector('[data-nh-newsletter-unavailable]');
    if (!dialog || !source || !formHost || !slot || !loading || !unavailable || typeof dialog.showModal !== 'function') return;
    let opener;
    let timer;
    let timedOut = false;

    function placeInDialog() {
      if (formHost.parentNode !== slot) slot.append(formHost);
      source.hidden = true;
    }

    function syncForm() {
      const form = formHost.querySelector('form, [role="form"]');
      const ready = !!form && (!!form.querySelector('input, button') || form.textContent.trim().length > 0);
      if (ready) {
        clearTimeout(timer);
        timedOut = false;
        placeInDialog();
      }
      loading.hidden = ready || timedOut;
      unavailable.hidden = ready || !timedOut;
      const rows = form && form.querySelector('input[type="email"]') ? form.querySelectorAll('[data-testid="form-row"]') : [];
      formHost.querySelectorAll('.nh-newsletter-form__title, .nh-newsletter-form__intro').forEach(row => {
        if (row !== rows[0]) row.classList.remove('nh-newsletter-form__title');
        if (row !== rows[1]) row.classList.remove('nh-newsletter-form__intro');
      });
      if (rows[0]) rows[0].classList.add('nh-newsletter-form__title');
      if (rows[1]) rows[1].classList.add('nh-newsletter-form__intro');
      return ready;
    }

    const observer = new MutationObserver(syncForm);
    observer.observe(formHost, { childList: true, subtree: true, characterData: true });
    syncForm();

    function onOpen(event) {
      const trigger = event.target.closest('[data-nh-newsletter-open]');
      if (!trigger) return;
      event.preventDefault();
      if (dialog.open) return;
      opener = trigger;
      timedOut = false;
      dialog.showModal();
      placeInDialog();
      document.body.classList.add('nh-newsletter-is-open');
      if (!syncForm()) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          timedOut = true;
          syncForm();
        }, 15000);
      }
    }

    function onClose() {
      clearTimeout(timer);
      document.body.classList.remove('nh-newsletter-is-open');
      if (!syncForm()) {
        source.hidden = false;
        source.append(formHost);
      }
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }

    function onDialogClick(event) {
      if (event.target.closest('[data-nh-newsletter-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    }

    document.addEventListener('click', onOpen);
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('close', onClose);
    cleanup = () => {
      observer.disconnect();
      clearTimeout(timer);
      document.removeEventListener('click', onOpen);
      dialog.removeEventListener('click', onDialogClick);
      dialog.removeEventListener('close', onClose);
      if (dialog.open) dialog.close();
      document.body.classList.remove('nh-newsletter-is-open');
      source.hidden = false;
      source.append(formHost);
      cleanup = null;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if ((event.target.matches('[data-nh-newsletter]') || event.target.querySelector('[data-nh-newsletter]')) && cleanup) cleanup();
  });
})();
